import { useCallback, useState } from 'react';
import type { Supplier } from '../types/supplier-types';

type UseSupplierModalReturn = {
  isSupplierModalOpen: boolean;
  selectedSupplier: Supplier | undefined;
  isEditMode: boolean;
  openAddSupplierModal: () => void;
  openEditSupplierModal: (supplier: Supplier) => void;
  closeSupplierModal: () => void;
};

export const useSupplierModal = (): UseSupplierModalReturn => {
  const [isSupplierModalOpen, setIsSupplierModalOpen] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState<Supplier | undefined>(undefined);
  const [isEditMode, setIsEditMode] = useState(false);

  const openAddSupplierModal = useCallback(() => {
    setSelectedSupplier(undefined);
    setIsEditMode(false);
    setIsSupplierModalOpen(true);
  }, []);

  const openEditSupplierModal = useCallback((supplier: Supplier) => {
    setSelectedSupplier(supplier);
    setIsEditMode(true);
    setIsSupplierModalOpen(true);
  }, []);

  const closeSupplierModal = useCallback(() => {
    setIsSupplierModalOpen(false);
    setSelectedSupplier(undefined);
    setIsEditMode(false);
  }, []);

  return {
    isSupplierModalOpen,
    selectedSupplier,
    isEditMode,
    openAddSupplierModal,
    openEditSupplierModal,
    closeSupplierModal,
  };
};
